<template>
  <AtomsCalculatorFrame
    iframe-class="!mx-auto"
    :type="type"
    :src="src"
  />
</template>

<script>
export default {
  name: 'MoleculesCalculatorStampDuty',

  data: () => ({
    type: 'Stamp_Duty_Calculator',
    src: '//www.visionabacus.net/Tools/B3/SuiteA/A200/Stamp_Duty_Calculator/CompareClub'
  })
}
</script>
